import 'magnific-popup';

$('.js-popup-image').magnificPopup({
  type: 'image',
  closeOnContentClick: true,
  mainClass: 'popup-image mfp-img-mobile',
  fixedContentPos: true,
  image: {
    verticalFit: true
  }
});
